import { Reveal } from "./Motion";

const base = "/images/projets/maison-sanaa-";
export const brandImages = {
  logo: { src: `${base}identite-logo.webp`, alt: "Logo Maison Sanaa, identité typographique avec repères de coupe", w: 2000, h: 452, cap: "01 — Identité" },
  creme: { src: `${base}collection-creme.webp`, alt: "Pot de crème Maison Sanaa sur pierre noire", w: 1024, h: 1536, cap: "02 — Packaging" },
  corps: { src: `${base}collection-soin-corps.webp`, alt: "Flacon pompe Maison Sanaa et gua sha noir", w: 1278, h: 1231, cap: "03 — Mise en scène" },
};

function Shot({ img, frame }) {
  return (
    <figure>
      <div className={`overflow-hidden bg-ink ${frame}`}>
        <img src={img.src} alt={img.alt} width={img.w} height={img.h} loading="lazy" decoding="async" className="h-full w-full object-cover" />
      </div>
      <figcaption className="label mt-3">{img.cap}</figcaption>
    </figure>
  );
}

export default function BrandGrid({ testid }) {
  const { logo, creme, corps } = brandImages;
  return (
    <div className="space-y-8" data-testid={testid}>
      <Reveal><Shot img={logo} frame="aspect-[2000/452]" /></Reveal>
      <div className="grid gap-8 md:grid-cols-2">
        <Reveal><Shot img={creme} frame="aspect-[4/5]" /></Reveal>
        <Reveal delay={0.08}><Shot img={corps} frame="aspect-[4/5]" /></Reveal>
      </div>
    </div>
  );
}
